import React from "react";

import pluralize from "pluralize";

import RadialStepCounter from "features/Setup/RadialStepCounter";

const OnboardingProgressIndicator: React.FunctionComponent<{
  stepsRemaining: number;
  trialExpired: boolean;
}> = ({ stepsRemaining, trialExpired }) => {
  let title, subtitle;
  if (trialExpired) {
    title = "Trial expired";
    subtitle = "Upgrade or renew trial";
  } else if (stepsRemaining === 0) {
    title = "Setup completed";
    subtitle = "Upgrade to paid plan";
  } else {
    title = "Set up pganalyze";
    subtitle = pluralize("remaining task", stepsRemaining, true);
  }

  return (
    <div className="flex items-center text-[var(--color-blue-50)]">
      <RadialStepCounter
        className="block my-auto mr-[2px] fill-[#c5bcce] stroke-[#c5bcce]"
        size={48}
        steps={3}
        completedSteps={3 - stepsRemaining}
      />
      <div className="my-auto">
        <div className="-mb-[3px] text-sm">{title}</div>
        <div className="text-xs text-[var(--color-blue-150)]">{subtitle}</div>
      </div>
    </div>
  );
};

export default OnboardingProgressIndicator;
